import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';
import { type CareerProfile } from 'CareerProfiles';
import {
    type GetStudentNetworkProfilesParams,
    type GetStudentNetworkProfilesResponse,
} from './studentNetworkV2Api.types';

type ProfilesResult = {
    profiles: CareerProfile[];
    totalCount: number;
};

export const studentNetworkProfilesApi = createApi('studentNetworkProfilesApi', {
    ...getBackRoyalApiBaseConfig('studentNetworkProfilesApi'),
    endpoints: builder => ({
        getStudentNetworkProfiles: builder.query<ProfilesResult, GetStudentNetworkProfilesParams>({
            query: params => ({
                // CareerProfile.index uses POST because filter params can be very long
                url: 'career_profiles/index.json',
                method: 'POST',
                body: params,
            }),
            transformResponse: (response: GetStudentNetworkProfilesResponse) => ({
                profiles: response.contents.careerProfiles,
                totalCount: response.meta.totalCount,
            }),
        }),
        getStudentNetworkProfileByUserId: builder.query<CareerProfile | undefined, string>({
            query: userId => ({
                url: 'career_profiles/index.json',
                method: 'POST',
                body: {
                    filters: { user_id: [userId] },
                    limit: 1,
                    offset: 0,
                    view: 'student_network_profiles',
                },
            }),
            transformResponse: (response: GetStudentNetworkProfilesResponse) => response.contents.careerProfiles[0],
        }),
    }),
});

export const { useGetStudentNetworkProfilesQuery, useGetStudentNetworkProfileByUserIdQuery } =
    studentNetworkProfilesApi;
